/**
 * Real bug: SavedBy Package Protection's own bundle (third-party CDN script, not theme code)
 * calls our cart drawer's <dialog>.close() a beat after showModal()'ing its own info tooltip
 * (#savedby-popup-dialog) when its "?" info icon is clicked. Confirmed by instrumenting
 * HTMLDialogElement.prototype.close/showModal: the close() call on the cart drawer's dialog
 * lands ~96ms after showModal() on #savedby-popup-dialog. Live's cart drawer stays open when
 * this icon is clicked, so this is a genuine divergence to fix, not a live behavior to reproduce.
 *
 * Can't edit SavedBy's own minified CDN bundle, so this briefly no-ops our dialog's close()
 * right after that specific icon is clicked. Every other close path (X button, Escape, backdrop
 * click, checkout, add-to-cart auto-open/close flows) is untouched, since none of them are
 * gated on a click landing inside .sb__info-help-button.
 */
const vcSavedbyGuard = { originalClose: null, restoreTimeout: null };

document.addEventListener(
  'click',
  (event) => {
    const isInfoButton = event
      .composedPath()
      .some((el) => el instanceof Element && el.classList.contains('sb__info-help-button'));
    if (!isInfoButton) return;

    const dialog = document.querySelector('#cart-drawer dialog');
    if (!(dialog instanceof HTMLDialogElement)) return;

    if (!vcSavedbyGuard.originalClose) {
      vcSavedbyGuard.originalClose = dialog.close.bind(dialog);
    }
    dialog.close = () => {};

    clearTimeout(vcSavedbyGuard.restoreTimeout);
    vcSavedbyGuard.restoreTimeout = setTimeout(() => {
      dialog.close = vcSavedbyGuard.originalClose;
      vcSavedbyGuard.originalClose = null;
    }, 500);
  },
  true,
);
